module.exports = __webpack_public_path__ + "static/media/siddharth-tirupati-trip-04.d2e3adb6.png";